export default __webpack_public_path__ + "static/media/sandwich.406700e5.jpg";